import { registerLocaleData } from '@angular/common';
import ru from '@angular/common/locales/ru';

import type { AppLang } from './app-lang';

type LazyAppLang = Exclude<AppLang, 'ru'>;

const LOCALE_LOADERS: Record<LazyAppLang, () => Promise<{ default: unknown }>> = {
  en: () => import('@angular/common/locales/en'),
  hy: () => import('@angular/common/locales/hy'),
  kk: () => import('@angular/common/locales/kk'),
  ky: () => import('@angular/common/locales/ky'),
  ko: () => import('@angular/common/locales/ko'),
  tt: () => import('@angular/common/locales/tt'),
  ce: () => import('@angular/common/locales/ce'),
  ba: () => import('@angular/common/locales/ba'),
  uz: () => import('@angular/common/locales/uz'),
  tg: () => import('@angular/common/locales/tg'),
};

const registeredLocales: Set<AppLang> = new Set<AppLang>(['ru']);

registerLocaleData(ru);

export async function registerAppLocaleData(lang: AppLang): Promise<void> {
  if (registeredLocales.has(lang)) {
    return;
  }

  const loader = LOCALE_LOADERS[lang as LazyAppLang];
  if (!loader) {
    registeredLocales.add(lang);
    return;
  }

  try {
    const locale = await loader();
    registerLocaleData(locale.default);
    registeredLocales.add(lang);
  } catch {
    // Словарь без locale-data не должен ломать переключение языка.
  }
}
